import { Skeleton } from "@/components/ui";
import React from "react";

export function SocialProfileLoadingState() {
  return (
    <div className="flex flex-col bg-slate-50/50 rounded-2xl p-2 border border-slate-100">
      <div className="flex items-center gap-3">
        <Skeleton className="w-[48px] h-[48px] rounded-full shrink-0" />
        <div className="flex flex-col gap-2 w-full">
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-3 w-1/3" />
        </div>
      </div>

      <div className="mt-2 pt-2 px-2 border-t border-slate-100 flex justify-between items-start">
        <div className="flex flex-col">
          <Skeleton className="h-3 w-16 mb-1.5" />
          <div className="flex items-baseline h-7">
            <Skeleton className="h-5 w-20" />
          </div>
        </div>
        <div className="flex flex-col items-end">
          <Skeleton className="h-3 w-12 mb-1.5" />
          <Skeleton className="h-4 w-24 mt-1" />
        </div>
      </div>
    </div>
  );
}
